import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';

import '@esi/leaf-web/lib/wc/components/tag-list/tag-list';
import type { LeafTagList } from '@esi/leaf-web/lib/wc/components/tag-list/tag-list';

@Component({
  selector: 'cigna-leaf-tag-list',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-tag-list [label]="label"><ng-content></ng-content></leaf-tag-list>
  `,
  styles: `
    :host ::ng-deep cigna-leaf-tag {
     margin-inline-start: calc(var(--size-base-unit)* 1);
     margin-block-start: calc(var(--size-base-unit)* 1);
    }
  `,
})
export class CignaLeafTagListComponent {
  @Input() label: LeafTagList['label'];
}
